import API from '../../../helpers/api';

import { message } from '../../../utils/message';

import CLIENT from '../actionTypes';

import { AppDispatch } from '../../../types/app';

export const changePassword =
  (values: {
    Type: string;
    PasswordCurrent: string;
    PasswordNew: string;
    PasswordNewConfirm: string;
  }) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: CLIENT.AUTH.CHANGE_PASSWORD.REQUESTING });

    try {
      await API.callGraphQL(
        `
      mutation (
        $Type: PasswordType!,
        $PasswordCurrent: String,
        $PasswordNew: String!,
        $PasswordNewConfirm: String!
      ) {
        result: clientChangePassword(
          Type: $Type,
          PasswordCurrent: $PasswordCurrent,
          PasswordNew: $PasswordNew,
          PasswordNewConfirm: $PasswordNewConfirm
        )
      }
    `,
        values
      );

      message.success('client.changePassword.success');

      return dispatch({
        type: CLIENT.AUTH.CHANGE_PASSWORD.SUCCESS,
      });
    } catch (err) {
      message.error(err);

      return dispatch({
        type: CLIENT.AUTH.CHANGE_PASSWORD.FAILURE,
        err: err.message,
      });
    }
  };
